import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Table,
  Space,
  Popconfirm,
  Modal
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, FileSearchOutlined, SearchOutlined } from "@ant-design/icons";


//mobx
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { toJS, runInAction, set } from "mobx";
//mobx'

import UnitInput from './UnitInput'

const Unit = () => {
  //mobx
  const { UnitStore } = useStore();

  //获得table数据
  useEffect(() => {
    UnitStore.getDataList();
    UnitStore.getSelectList()
    UnitStore.getSelectList2()
    // eslint-disable-next-line
  }, []);

  //分页控制
  const onPageChange = (page, pageSize) => {
    runInAction(() => {
      set(UnitStore, { page: page, pagesize: pageSize })
    })
    UnitStore.getDataList()
  }
  //分页控制

  //关闭X按钮
  const handleRevise = () => {
    runInAction(() => {
      set(UnitStore, { isActive: false });
    });
  };

  //单个删除按钮
  const deleteConfirm = async (item) => {
    let id = toJS(item).aid;
    toJS(UnitStore.dataList).filter((item) => item.aid !== id);
    await UnitStore.getDeleteButtom(id);
  };

  //新增账户
  const getAddButton = (addTitle, data) => {
    if (addTitle === '编辑' || addTitle === '查看') {
      runInAction(() => {
        set(UnitStore, { valueData: toJS(data) });
      })
    }
    runInAction(() => {
      set(UnitStore, { title: addTitle, isActive: true });
    });
  };

  // 取消按钮
  const [form] = Form.useForm();


  //表单提交
  const onFinish = async (values) => {
    if (values.name) {
      runInAction(() => {
        set(UnitStore, { dymc: values.name, page: 1 })
      })
      await UnitStore.getDataList();
    } else if (values.name === undefined || values.name === '') {
      runInAction(() => {
        set(UnitStore, { dymc: '', page: 1 })
      })
      await UnitStore.getDataList();
    }

  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const start = async () => {

    setLoading(true);
    await UnitStore.getDeleteButtom(toJS(UnitStore.moreId));

    setTimeout(() => {
      setSelectedRowKeys([]);
      setLoading(false);
    }, 1000);
  };
  const onSelectChange = (newSelectedRowKeys) => {
    runInAction(() => {
      set(UnitStore, { moreId: newSelectedRowKeys.toString() })
    })
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  //table 列表
  const columns = [
    {
      title: "ID",
      dataIndex: "aid",
    },
    {
      title: "所属系统",
      dataIndex: "xtmc",
    },
    {
      title: "所属企业",
      dataIndex: "qymc",
    },
    {
      title: "单元编号",
      dataIndex: "dybh",
    },
    {
      title: "单元名称",
      dataIndex: "dymc",
    },
    {
      title: "联系人",
      dataIndex: "lxr",
    },
    {
      title: "联系电话",
      dataIndex: "lxdh",
    },
    {
      title: "经度",
      dataIndex: "jd",
    },
    {
      title: "纬度",
      dataIndex: "wd",
    },
    {
      title: "创建时间",
      dataIndex: "createtime",
    },
    {
      title: "操作",
      render: (item) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<FileSearchOutlined />}
            style={{ background: '#40ad63' }}
            onClick={() => getAddButton("查看", item)}
          >查看</Button>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => getAddButton("编辑", item)}
          >编辑</Button>
          <Popconfirm
            title="是否删除?"
            okText="确定"
            cancelText="取消"
            onConfirm={() => {
              deleteConfirm(item);
            }}
          >
            {<Button type="primary" icon={<DeleteOutlined />} danger>删除</Button>}
          </Popconfirm>

        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="searchBox">
        <Form
          layout="inline"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item label="关键词" name="name">
            <Input placeholder="请输入单元名称" style={{ width: "260px" }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ background: '#40ad63' }}>
              查询
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="TableInput">
        <div className="buttonBox">
          <Popconfirm
            title="是否删除?"
            okText="确定"
            cancelText="取消"
            onConfirm={() => {
              start()
            }}
          >
            {<Button type="primary" icon={<DeleteOutlined />} style={{ background: '#6a8d9f', marginRight: '10px' }} disabled={!hasSelected} >
              批量删除
            </Button>}
          </Popconfirm>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            className="addTitle"
            onClick={() => getAddButton("添加", '')}
          >
            添加单元
          </Button>
        </div>
        <div className="total">共有数据:{UnitStore.total}条</div>
      </div>

      <div className="contextNr">
        <Table
          rowKey={(record) => record.aid}
          columns={columns}
          dataSource={UnitStore.dataList}
          rowSelection={rowSelection}
          className="table-box"
          pagination={{
            position: ["bottomCenter"],
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ['10', '20', '30'],
            pageSize: UnitStore.pagesize,
            current: UnitStore.page,
            total: UnitStore.total,
            onChange: (page, pageSize) => onPageChange(page, pageSize),
          }}
        />
      </div>
      <Modal
        title={UnitStore.title}
        key={new Date()}
        width="600px"
        open={UnitStore.isActive}
        footer={null}
        onCancel={handleRevise}
      >
        <UnitInput title={UnitStore.title} />
      </Modal>
    </>
  );
};

export default observer(Unit);
